import {useTranslate} from 'src/common/i18n/useTranslate'
import type {UrlObject} from 'url'
import {BlockContainer} from './components/BlockContainer'
import {Button} from './components/Button'
import {FactCard} from './components/FactCard'

export type Need = {
  label: string
  detail: string
  buttonLabel: string
  buttonHref?: string | UrlObject
  buttonTarget?: string
  buttonLocale?: string
}

export type PrerequisitesPanelProps = {
  heading: string
  needs: Need[]
  timeEstimate: string
  effortLevel: string
  endResult: string
  pageUid: string
}

export const PrerequisitesPanel = ({
  heading,
  needs,
  timeEstimate,
  effortLevel,
  endResult,
  pageUid,
}: PrerequisitesPanelProps) => {
  const translate = useTranslate()

  return (
    <section
      data-slice-type="discovery_block"
      data-slice-variation="prerequisitesPanel"
      data-nav-dark="true"
      className="grid grid-cols-main bg-green-base bg-discovery-glow bg-fixed px-5 py-12 md:px-10 md:py-16"
    >
      <div className="col-[inner] w-full max-w-[46.25rem] justify-self-center">
        <BlockContainer headline={heading}>
          <div className="flex flex-wrap gap-3">
            {needs.map((need, needIndex) => (
              <FactCard
                key={needIndex}
                icon="key"
                value={need.label}
                detail={need.detail}
                action={
                  need.buttonLabel && need.buttonHref ? (
                    <Button
                      href={need.buttonHref}
                      target={need.buttonTarget}
                      locale={need.buttonLocale}
                      full
                      trackingData={{
                        mktgId: 'discovery-block-prerequisite',
                        location: 'prerequisites-panel',
                        dataType: 'prerequisite-need-button',
                        pageName: pageUid,
                      }}
                    >
                      {need.buttonLabel}
                    </Button>
                  ) : undefined
                }
              />
            ))}
            {timeEstimate && <FactCard icon="clock" label={translate('discoveryBlock.time')} value={timeEstimate} />}
            {effortLevel && <FactCard icon="bolt" label={translate('discoveryBlock.effort')} value={effortLevel} />}
            {endResult && <FactCard icon="chart" label={translate('discoveryBlock.endResult')} value={endResult} />}
          </div>
        </BlockContainer>
      </div>
    </section>
  )
}
